import { GOOGLE_MAPS_API_KEY } from "../config/apiKey";

export const loadGoogleMaps = (onLoadCallback) => {
  if (!document.querySelector('script[src^="https://maps.googleapis.com/maps/api/js"]')) {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}`;
    script.async = true;
    script.defer = true;
    script.onload = onLoadCallback;
    document.body.appendChild(script);
  } else if (window.google) {
    onLoadCallback();
  }
};
